import type { Distance, Point } from "@pdfking/math"
import { Center } from "@pdfking/math"

import type { Matrix } from "#public"
import type { MediaEntry } from "#public"
import type { PlotMedia } from "#public"

import { GroupMatrix } from "./GroupMatrix"
import { MatrixCompose } from "./MatrixCompose"

/** A media's whole matrix: its file entry's, moved onto the box's centre, then
 * its own `media_matrix`. No entry, just its own. */
export const MediaEntryMatrix = (
  entry: MediaEntry | undefined,
  { position, media_matrix }: Pick<PlotMedia, "position" | "media_matrix">
): Matrix<Distance> => {
  if (!entry) return media_matrix
  const { x, y } = Center(position)
  const to = GroupMatrix({ translate: { x, y } })
  const from = GroupMatrix({ translate: { x: -x, y: -y } as Point<Distance> })
  return MatrixCompose(MatrixCompose(MatrixCompose(from, entry.matrix), to), media_matrix)
}
